module.exports = __webpack_public_path__ + "img/zwt.816d5f51.png";